<template>
    <div class="tab-pane p-20 active">
        <PmlUpload :open="showForm" :deal="deal"></PmlUpload>
        <div class="row">
            <div class="col-md-6 m_bottom_15">
                <button class="btn btn-inverse" @click="showForm = true" v-if="!showForm && deal.editable">
                    <span class="btn-label">
                        <i class="fa fa-upload"></i>
                    </span>
                    {{ $t('upload') }}
                </button>
                <button class="btn btn-white" @click="showForm = false"  v-if="showForm && deal.editable"> {{ $t('cancel') }}</button>
                <span class="pull-right m-t-10">{{ $t('data_grid_entries_showing', [attachments.length]) }}</span>
            </div>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="search" :placeholder="`${$t('search')}...`">
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 ">
                <div class="portfolioFilter">
                    <a href="#" @click.prevent="type = ''" :class="{ 'current': type == '' }">{{ $t('all') }}</a>
                    <a href="#" @click.prevent="type = 'document'" :class="{ 'current': type == 'documents' }">{{ $t('documents') }}</a>
                    <a href="#" @click.prevent="type = 'pdf'" :class="{ 'current': type == 'pdf' }">{{ $t('pdf') }}</a>
                    <a href="#" @click.prevent="type = 'image'" :class="{ 'current': type == 'image' }">{{ $t('images') }}</a>
                    <a href="#" @click.prevent="type = 'compressed'" :class="{ 'current': type == 'compressed' }">{{ $t('compressed') }}</a>
                </div>
            </div>
        </div>
        <div class="row port">
            <div class="portfolioContainer files_upload">
                <PmlItem v-for="item in attachments" :key="item.id" :item="item"></PmlItem>
                <div v-if="!attachments.length">
                    <p class="t_center m-t-20">
                        <i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PmlUpload from './Upload.vue'
    import PmlItem from './Item.vue'
    import { sanitizeAndLower } from 'utils/helpers/strings'
    import { isEmpty, filter, orderBy, isNull } from 'lodash'
    import { mapGetters } from 'vuex'

    export default {
        name: 'Attachments',
        components: { PmlUpload, PmlItem },
        data () {
            return {
                showForm: false,
                search: '',
                type: ''
            }
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo',
                'items': 'getDealAttachments'
            }),
            attachments () {
                const search = sanitizeAndLower(this.search)
                let list = orderBy(this.items, ['name'], ['asc']) || []

                if (this.type !== '')
                    list = filter(list, response => {
                        if (typeof response.type !== 'undefined' && !isNull(response.type))
                            return response.type.indexOf(this.type) >= 0
                    })

                if (isEmpty(search))
                    return list

                return filter(list, response => sanitizeAndLower(response.name).indexOf(search) >= 0)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/attachments/Main.vue